import { getRequest } from '@/core';
import { trips } from '@/requests';
export default async function getTripsRequest(filter) {
	try {
		let url = trips.getFilterPath();
		return await getRequest(url, filter);
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
